import {
  ApiOutlined,
  ThunderboltFilled,
  ThunderboltOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import React, { useContext, useState } from 'react';

import { MenuCustom } from 'app/components/commons/MenuCustom/MenuCustom';
import { ExtranetHeader } from 'app/components/pages/Extranet/commons/ExtranetHeader/ExtranetHeader';
import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { amplitudeTrack } from 'app/utils/track/amplitude';

import type { InventoryTabItem } from '../../../InventoryStore';
import { INVENTORY_TAB_ITEMS } from '../../../InventoryStore';
import { AutoInventoryModal } from '../../../_modals/AutoInventoryModal/AutoInventoryModal';
import {
  useInventoryHeaderActions,
  useInventoryHeaderState,
} from '../../../hooks';
import { InventoryControls } from '../ActionsBar/InventoryControls/InventoryControls';
import { TimePeriods } from '../TimePeriods/TimePeriods';

import style from './InventoryHeader.module.scss';
import { useInventoryActions } from './hooks/useInventoryActions';
import { useInventoryConfig } from './hooks/useInventoryConfig';

export type InventoryHeaderProps = {
  page: string;
};

export const InventoryHeader: React.FC<InventoryHeaderProps> = ({ page }) => {
  const { isEditMode, tab, packType } = useInventoryHeaderState();
  const { changeTab, setChangesModalData } = useInventoryHeaderActions();
  const { hotelId } = useContext(HotelContext);

  const [isAutoInventoryModalOpen, setIsAutoInventoryModalOpen] =
    useState(false);

  // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
  const clickMenu = (tab: InventoryTabItem) => {
    if (isEditMode && setChangesModalData) {
      setChangesModalData({ isVisible: true, tabSelect: tab.name });
    } else {
      changeTab(tab);

      amplitudeTrack('Click Inventory tab', {
        tab: tab.name,
        tabType: packType,
      });
    }
  };

  const getIconPR = (isActive: boolean) => {
    return isActive ? (
      <ThunderboltFilled style={{ color: '#0C3B7C' }} />
    ) : (
      <ThunderboltOutlined />
    );
  };

  const handlers = useInventoryActions();
  const controlsConfig = useInventoryConfig(
    {
      ...handlers,
      onAutoInventory: () => setIsAutoInventoryModalOpen(true),
    },
    {
      saveDisabled: false,
      saving: false,
      bulkEditIcon: <UnorderedListOutlined />,
      pricingConfigurationIcon: getIconPR(false),
      autoInventoryIcon: <ApiOutlined />,
    }
  );

  return (
    <div className={style.extranetInventoryHeader}>
      <ExtranetHeader page={page} className="no-border-bottom" />
      <div className={style.inventoryHeaderContent}>
        <div className={style.inventoryTab}>
          <MenuCustom
            menuItems={INVENTORY_TAB_ITEMS}
            selectedMenu={tab}
            setSelectedMenu={clickMenu}
          />
        </div>
        <div className={style.actionsPart}>
          {controlsConfig && <InventoryControls {...controlsConfig} />}
        </div>
        <div className={style.timePeriod}>
          <TimePeriods />
        </div>
      </div>
      <AutoInventoryModal
        isOpen={isAutoInventoryModalOpen}
        hotelId={hotelId}
        onClose={() => setIsAutoInventoryModalOpen(false)}
        onConfirmChannelManager={() => setIsAutoInventoryModalOpen(false)}
      />
    </div>
  );
};
